var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import "../../Utilities.js";
import "../../Styling.js";
import { Panel as Panel$1 } from "@fluentui/react/lib/Panel";
import { getId } from "@fluentui/utilities";
import { mergeStyles, mergeStyleSets } from "@fluentui/style-utilities";
const defaultClassName = "ane-Panel";
const contentClassName = "ane-Panel-content";
const footerClassName = "ane-Panel-footer";
class Panel extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_onRenderFooter", (props) => {
      const { onRenderFooter } = this.props;
      if (!onRenderFooter) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: mergeStyles(
            {
              margin: "20px"
            },
            `${footerClassName}-${props.type}`
          ),
          children: onRenderFooter(props)
        }
      );
    });
  }
  render() {
    const _a = this.props, { children, className, id = getId("Panel"), type, closeButtonAriaLabel = "Close Panel", styles } = _a, rest = __objRest(_a, ["children", "className", "id", "type", "closeButtonAriaLabel", "styles"]);
    return /* @__PURE__ */ jsx(
      Panel$1,
      __spreadProps(__spreadValues({}, rest), {
        closeButtonAriaLabel,
        className: mergeStyles(defaultClassName, `${defaultClassName}-${type}`),
        styles: mergeStyleSets(
          {
            root: {
              /**
               * [a11y zoom]
               * Allow users to scroll the entire panel
               */
              "@media screen and (max-height: 680px)": {
                overflowY: "auto"
              }
            },
            contentInner: {
              /**
               * [a11y zoom]
               * Allow users to scroll the entire panel
               */
              "@media screen and (max-height: 680px)": {
                overflowY: "visible"
              }
            }
          },
          styles
        ),
        id,
        onRenderFooter: () => this._onRenderFooter(this.props),
        type,
        children: /* @__PURE__ */ jsx("div", { className: mergeStyles(contentClassName, className), children })
      })
    );
  }
}
__publicField(Panel, "defaultProps", {
  headerText: ""
});
export {
  Panel,
  Panel as default
};
//# sourceMappingURL=Panel.js.map
